export const mandatoryMainCloseReasons = ['Lost', 'Delete', 'Duplicated']
